import { render, staticRenderFns } from "./GridSection.vue?vue&type=template&id=e1004cd8&scoped=true&"
import script from "./GridSection.vue?vue&type=script&lang=js&"
export * from "./GridSection.vue?vue&type=script&lang=js&"
import style0 from "./GridSection.vue?vue&type=style&index=0&id=e1004cd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1004cd8",
  null
  
)

export default component.exports